/**
 * FLOWERS ON RAMARAMA
 * Product Delivery Options & Add-ons JavaScript
 * Version 9.0 - Click validation to scroll, Location Type removed from validation
 * 
 * DELIVERY requires: Town/Postcode, Card Message, Phone, Occasion, Date
 * PICKUP requires: Occasion, Date
 * Optional: Special Instructions (both), Card Message (pickup only), Location Type (has default)
 */

console.log('🌸 Flowers on Ramarama: Script loaded v9.0');

(function() {
  'use strict';

  // Default configuration (overridden by section settings)
  let CONFIG = {
    cutoffTimes: {
      weekday: { hour: 13, minute: 30 },
      saturday: { hour: 11, minute: 0 }
    },
    timezone: 'Pacific/Auckland',
    blockedWeekdays: [true, false, false, false, false, false, false],
    blockedDates: [],
    blockedRanges: [],
    unblockedDates: [],
    pickupAddress: 'PICKUP - 119 Ramarama Road, Drury',
    dateTitleDelivery: 'When Would You Like Your Order Delivered?',
    dateTitlePickup: 'When Would You Like To Pick Up?'
  };

  let currentDeliveryMethod = 'delivery';
  let isSubmitting = false;
  let userHasInteracted = false;

  // ============================================
  // LOAD SETTINGS FROM SECTION
  // ============================================

  function loadSectionSettings() {
    const settingsEl = document.querySelector('[data-delivery-settings]');
    if (!settingsEl) {
      console.warn('🌸 No delivery settings element found');
      return;
    }
    
    try {
      const settings = JSON.parse(settingsEl.textContent);
      
      CONFIG.cutoffTimes.weekday.hour = settings.cutoffWeekdayHour || 13;
      CONFIG.cutoffTimes.weekday.minute = settings.cutoffWeekdayMinute || 30;
      CONFIG.cutoffTimes.saturday.hour = settings.cutoffSaturdayHour || 11;
      CONFIG.cutoffTimes.saturday.minute = settings.cutoffSaturdayMinute || 0;
      CONFIG.pickupAddress = settings.pickupAddress || CONFIG.pickupAddress;
      
      if (settings.blockedWeekdays && Array.isArray(settings.blockedWeekdays)) {
        CONFIG.blockedWeekdays = settings.blockedWeekdays.map(v => v === true || v === 'true');
      }
      
      if (settings.blockedDatesRaw && typeof settings.blockedDatesRaw === 'string') {
        CONFIG.blockedDates = settings.blockedDatesRaw
          .split(/[\r\n]+/)
          .map(d => d.trim())
          .filter(d => d && /^\d{4}-\d{2}-\d{2}$/.test(d));
      }
      
      CONFIG.blockedRanges = [];
      if (settings.blockedRange1Start && settings.blockedRange1End) {
        CONFIG.blockedRanges.push({
          start: settings.blockedRange1Start.trim(),
          end: settings.blockedRange1End.trim()
        });
      }
      if (settings.blockedRange2Start && settings.blockedRange2End) {
        CONFIG.blockedRanges.push({
          start: settings.blockedRange2Start.trim(),
          end: settings.blockedRange2End.trim()
        });
      }
      
      if (settings.unblockedDatesRaw && typeof settings.unblockedDatesRaw === 'string') {
        CONFIG.unblockedDates = settings.unblockedDatesRaw
          .split(/[\r\n]+/)
          .map(d => d.trim())
          .filter(d => d && /^\d{4}-\d{2}-\d{2}$/.test(d));
      }
      
      console.log('🌸 Delivery settings loaded');
    } catch (e) {
      console.error('🌸 Could not parse section settings:', e);
    }
  }

  // ============================================
  // DATE UTILITY FUNCTIONS
  // ============================================

  function getNZDate() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: CONFIG.timezone }));
  }

  function formatDateShort(date) {
    const options = { weekday: 'short', day: 'numeric', month: 'short' };
    return date.toLocaleDateString('en-NZ', options);
  }

  function formatDateForInput(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  function parseDate(dateStr) {
    const [year, month, day] = dateStr.split('-').map(Number);
    return new Date(year, month - 1, day);
  }

  // ============================================
  // CUSTOM CALENDAR
  // ============================================

  let currentCalendarMonth = null;
  let currentCalendarYear = null;
  let selectedCalendarDate = null;

  function initCustomCalendar() {
    const calendar = document.querySelector('[data-custom-calendar]');
    if (!calendar) return;

    const today = getNZDate();
    currentCalendarMonth = today.getMonth();
    currentCalendarYear = today.getFullYear();

    const prevBtn = calendar.querySelector('[data-calendar-prev]');
    const nextBtn = calendar.querySelector('[data-calendar-next]');

    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        currentCalendarMonth--;
        if (currentCalendarMonth < 0) {
          currentCalendarMonth = 11;
          currentCalendarYear--;
        }
        renderCalendar();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        currentCalendarMonth++;
        if (currentCalendarMonth > 11) {
          currentCalendarMonth = 0;
          currentCalendarYear++;
        }
        renderCalendar();
      });
    }

    renderCalendar();
  }

  function renderCalendar() {
    const calendar = document.querySelector('[data-custom-calendar]');
    if (!calendar) return;

    const monthYearEl = calendar.querySelector('[data-calendar-month-year]');
    const daysContainer = calendar.querySelector('[data-calendar-days]');
    
    if (!monthYearEl || !daysContainer) return;

    const today = getNZDate();
    const todayStr = formatDateForInput(today);

    // Month names
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
                        'July', 'August', 'September', 'October', 'November', 'December'];

    // Update header
    monthYearEl.textContent = `${monthNames[currentCalendarMonth]} ${currentCalendarYear}`;

    // Clear previous days
    daysContainer.innerHTML = '';

    // Get first day of month and total days
    const firstDay = new Date(currentCalendarYear, currentCalendarMonth, 1);
    const lastDay = new Date(currentCalendarYear, currentCalendarMonth + 1, 0);
    const startingDay = firstDay.getDay(); // 0 = Sunday
    const totalDays = lastDay.getDate();

    // Add empty cells for days before the first
    for (let i = 0; i < startingDay; i++) {
      const emptyDay = document.createElement('button');
      emptyDay.type = 'button';
      emptyDay.className = 'custom-calendar__day custom-calendar__day--empty';
      emptyDay.disabled = true;
      daysContainer.appendChild(emptyDay);
    }

    // Add days of the month
    for (let day = 1; day <= totalDays; day++) {
      const date = new Date(currentCalendarYear, currentCalendarMonth, day);
      const dateStr = formatDateForInput(date);
      const dayBtn = document.createElement('button');
      dayBtn.type = 'button';
      dayBtn.className = 'custom-calendar__day';
      dayBtn.textContent = day;
      dayBtn.setAttribute('data-date', dateStr);

      // Check if today
      if (dateStr === todayStr) {
        dayBtn.classList.add('custom-calendar__day--today');
      }

      // Check if selected
      if (selectedCalendarDate && dateStr === selectedCalendarDate) {
        dayBtn.classList.add('custom-calendar__day--selected');
      }

      // Check if past date
      const isPast = date < new Date(today.getFullYear(), today.getMonth(), today.getDate());
      
      // Check if blocked
      const isBlocked = isDateBlocked(date);

      // Check if today but past cutoff
      const isTodayPastCutoff = dateStr === todayStr && !isBeforeCutoff();

      if (isPast || isBlocked || isTodayPastCutoff) {
        dayBtn.classList.add('custom-calendar__day--disabled');
        if (isBlocked && !isPast) {
          dayBtn.classList.add('custom-calendar__day--blocked');
          dayBtn.title = 'Delivery not available';
        } else if (isPast) {
          dayBtn.classList.add('custom-calendar__day--past');
          dayBtn.title = 'Past date';
        } else if (isTodayPastCutoff) {
          dayBtn.title = 'Past cutoff time';
        }
        dayBtn.disabled = true;
      } else {
        // Add click handler for available dates
        dayBtn.addEventListener('click', function(e) {
          e.preventDefault();
          selectCalendarDate(dateStr, date);
        });
      }

      daysContainer.appendChild(dayBtn);
    }
  }

  function selectCalendarDate(dateStr, date) {
    selectedCalendarDate = dateStr;
    
    // Update hidden input
    const dateInput = document.querySelector('[data-date-picker-input]');
    if (dateInput) {
      dateInput.value = dateStr;
    }

    // Sync to hidden form field
    syncToHiddenInput('input-delivery-date', formatDateShort(date));
    
    // Mark user interaction
    markUserInteraction();
    
    // Update button state
    updateAddToCartButton();
    
    // Re-render calendar to show selection
    renderCalendar();
  }

  // ============================================
  // COUNTDOWN TIMER
  // ============================================

  let countdownInterval = null;

  function startCountdownTimer() {
    const countdownWrapper = document.querySelector('[data-countdown-wrapper]');
    const hoursEl = document.querySelector('[data-countdown-hours]');
    const minutesEl = document.querySelector('[data-countdown-minutes]');
    const secondsEl = document.querySelector('[data-countdown-seconds]');
    const labelEl = document.querySelector('.delivery-countdown__label');

    if (!countdownWrapper || !hoursEl || !minutesEl || !secondsEl) {
      return;
    }

    // Clear any existing interval
    if (countdownInterval) {
      clearInterval(countdownInterval);
    }

    function updateCountdown() {
      const now = getNZDate();
      const dayOfWeek = now.getDay();

      // Check if today is blocked or Sunday (no same-day delivery)
      if (isDateBlocked(now) || dayOfWeek === 0) {
        countdownWrapper.style.display = 'none';
        return;
      }

      // Get cutoff time for today
      const cutoff = dayOfWeek === 6 ? CONFIG.cutoffTimes.saturday : CONFIG.cutoffTimes.weekday;
      
      // Create cutoff datetime for today
      const cutoffTime = new Date(now);
      cutoffTime.setHours(cutoff.hour, cutoff.minute, 0, 0);

      // Calculate time remaining
      const diff = cutoffTime - now;

      if (diff <= 0) {
        // Cutoff has passed
        countdownWrapper.classList.remove('delivery-countdown--urgent');
        countdownWrapper.classList.add('delivery-countdown--expired');
        if (labelEl) labelEl.textContent = 'Same-day delivery cutoff has passed. Select tomorrow or a later date.';
        hoursEl.textContent = '00';
        minutesEl.textContent = '00';
        secondsEl.textContent = '00';
        countdownWrapper.style.display = 'block';
        
        // Stop the interval after expiry
        if (countdownInterval) {
          clearInterval(countdownInterval);
          countdownInterval = null;
        }
        return;
      }

      // Calculate hours, minutes, seconds
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      // Update display
      hoursEl.textContent = String(hours).padStart(2, '0');
      minutesEl.textContent = String(minutes).padStart(2, '0');
      secondsEl.textContent = String(seconds).padStart(2, '0');

      // Check if urgent (less than 30 minutes)
      const totalMinutes = hours * 60 + minutes;
      if (totalMinutes < 30) {
        countdownWrapper.classList.add('delivery-countdown--urgent');
        countdownWrapper.classList.remove('delivery-countdown--expired');
      } else {
        countdownWrapper.classList.remove('delivery-countdown--urgent');
        countdownWrapper.classList.remove('delivery-countdown--expired');
      }

      if (labelEl) labelEl.textContent = 'Same-day delivery closes in:';
      countdownWrapper.style.display = 'block';
    }

    // Initial update
    updateCountdown();

    // Update every second
    countdownInterval = setInterval(updateCountdown, 1000);
  }

  function stopCountdownTimer() {
    if (countdownInterval) {
      clearInterval(countdownInterval);
      countdownInterval = null;
    }
    const countdownWrapper = document.querySelector('[data-countdown-wrapper]');
    if (countdownWrapper) {
      countdownWrapper.style.display = 'none';
    }
  }

  // ============================================
  // CALENDAR BLOCKING FUNCTIONS
  // ============================================

  function isDateBlocked(date) {
    const dateStr = formatDateForInput(date);
    const dayOfWeek = date.getDay();

    if (CONFIG.unblockedDates && CONFIG.unblockedDates.includes(dateStr)) {
      return false;
    }

    if (CONFIG.blockedWeekdays && CONFIG.blockedWeekdays[dayOfWeek] === true) {
      return true;
    }

    if (CONFIG.blockedDates && CONFIG.blockedDates.includes(dateStr)) {
      return true;
    }

    if (CONFIG.blockedRanges && CONFIG.blockedRanges.length > 0) {
      for (const range of CONFIG.blockedRanges) {
        if (range.start && range.end) {
          const startDate = parseDate(range.start);
          const endDate = parseDate(range.end);
          const checkDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
          
          if (checkDate >= startDate && checkDate <= endDate) {
            return true;
          }
        }
      }
    }

    return false;
  }

  function getNextAvailableDate(startDate) {
    let date = new Date(startDate);
    let attempts = 0;
    const maxAttempts = 60;

    while (isDateBlocked(date) && attempts < maxAttempts) {
      date.setDate(date.getDate() + 1);
      attempts++;
    }

    return date;
  }

  function isBeforeCutoff() {
    const now = getNZDate();
    const dayOfWeek = now.getDay();
    const hour = now.getHours();
    const minute = now.getMinutes();

    if (isDateBlocked(now)) {
      return false;
    }

    const cutoff = dayOfWeek === 6 ? CONFIG.cutoffTimes.saturday : CONFIG.cutoffTimes.weekday;
    return (hour < cutoff.hour) || (hour === cutoff.hour && minute < cutoff.minute);
  }

  // ============================================
  // SYNC & VALIDATION FUNCTIONS
  // ============================================

  function syncToHiddenInput(hiddenId, value) {
    const hidden = document.getElementById(hiddenId);
    if (hidden) {
      hidden.value = value;
    }
  }

  function getFieldValue(fieldId) {
    const hiddenInput = document.getElementById(fieldId);
    return hiddenInput ? hiddenInput.value.trim() : '';
  }

  function validateForm() {
    let isValid = true;
    let missingFields = [];

    // Date is required for both delivery and pickup
    if (!getFieldValue('input-delivery-date')) {
      isValid = false;
      missingFields.push('date');
    }

    // Occasion is required for both
    if (!getFieldValue('input-occasion')) {
      isValid = false;
      missingFields.push('occasion');
    }

    if (currentDeliveryMethod === 'delivery') {
      // Delivery-specific required fields
      if (!getFieldValue('input-delivery-suburb')) {
        isValid = false;
        missingFields.push('recipient town/postcode');
      }
      
      // Location type removed from validation - always has default value
      
      if (!getFieldValue('input-card-message')) {
        isValid = false;
        missingFields.push('card message');
      }
      
      if (!getFieldValue('input-recipient-phone')) {
        isValid = false;
        missingFields.push('recipient phone');
      }
    }
    // For pickup: card message and special instructions are optional

    return { isValid, missingFields };
  }

  function markUserInteraction() {
    userHasInteracted = true;
  }

  function updateAddToCartButton(showMessage = true) {
    const validation = validateForm();
    const submitButtons = document.querySelectorAll('.product-form__submit');
    const validationMessage = document.getElementById('delivery-validation-message');

    submitButtons.forEach(function(btn) {
      const originallyDisabled = btn.querySelector('span')?.textContent?.toLowerCase().includes('sold out') ||
                                  btn.querySelector('span')?.textContent?.toLowerCase().includes('unavailable');
      
      if (originallyDisabled) return;

      if (validation.isValid) {
        btn.disabled = false;
        btn.dataset.disabledByValidation = 'false';
        btn.style.opacity = '1';
        btn.style.cursor = 'pointer';
      } else {
        btn.disabled = true;
        btn.dataset.disabledByValidation = 'true';
        btn.style.opacity = '0.5';
        btn.style.cursor = 'not-allowed';
      }
    });

    if (validationMessage) {
      if (validation.isValid) {
        validationMessage.style.display = 'none';
        validationMessage.onclick = null;
      } else if (userHasInteracted && showMessage) {
        validationMessage.textContent = 'Please select: ' + validation.missingFields.join(', ');
        validationMessage.style.display = 'block';
        validationMessage.style.cursor = 'pointer';
        
        // Store first missing field for scroll
        var firstMissing = validation.missingFields[0];
        
        // Add click handler to scroll to first error
        validationMessage.onclick = function() {
          scrollToFirstMissingField(firstMissing);
        };
      } else {
        validationMessage.style.display = 'none';
      }
    }
  }
  
  // Scroll to first missing field
  function scrollToFirstMissingField(fieldName) {
    var fieldMap = {
      'date': { section: '[data-required-section="date"]', input: '[data-date-picker-input]', fallback: '.delivery-date__quick-options' },
      'recipient town/postcode': { section: '[data-required-section="suburb"]', input: '[data-suburb-input]' },
      'card message': { section: '[data-required-section="cardMessage"]', input: '[data-card-message-input]' },
      'recipient phone': { section: '[data-required-section="phone"]', input: '[data-recipient-phone-input]' },
      'occasion': { section: '[data-required-section="occasion"]', input: '[data-occasion-input]' }
    };
    
    var field = fieldMap[fieldName];
    if (!field) {
      console.log('🌸 Unknown field:', fieldName);
      return;
    }
    
    // Try to find the section first
    var targetElement = document.querySelector(field.section);
    if (!targetElement && field.fallback) {
      targetElement = document.querySelector(field.fallback);
    }
    if (!targetElement) {
      targetElement = document.querySelector(field.input);
    }
    
    if (targetElement) {
      console.log('🌸 Scrolling to:', fieldName);
      targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      
      // Try to focus the input
      setTimeout(function() {
        var input = document.querySelector(field.input);
        if (!input && targetElement) {
          input = targetElement.querySelector('input:not([type="hidden"]), select, textarea');
        }
        if (input && typeof input.focus === 'function') {
          input.focus();
        }
      }, 500);
    } else {
      console.log('🌸 Could not find element for:', fieldName);
    }
  }

  // ============================================
  // CLEAR/RESET FORM
  // ============================================

  function clearDeliveryForm() {
    isSubmitting = false;
    userHasInteracted = false;

    syncToHiddenInput('input-delivery-date', '');
    syncToHiddenInput('input-delivery-suburb', '');
    syncToHiddenInput('input-location-type', 'Residential Home');
    syncToHiddenInput('input-card-message', '');
    syncToHiddenInput('input-recipient-phone', '');
    syncToHiddenInput('input-occasion', '');
    syncToHiddenInput('input-special-instructions', '');
    syncToHiddenInput('input-delivery-method', 'Delivery');

    // Reset visible inputs
    const suburbInput = document.querySelector('[data-suburb-input]');
    if (suburbInput) suburbInput.value = '';

    const locationTypeInput = document.querySelector('[data-location-type-input]');
    if (locationTypeInput) locationTypeInput.selectedIndex = 0;

    const cardMessageInput = document.querySelector('[data-card-message-input]');
    if (cardMessageInput) cardMessageInput.value = '';

    const phoneInput = document.querySelector('[data-recipient-phone-input]');
    if (phoneInput) phoneInput.value = '';

    const occasionInput = document.querySelector('[data-occasion-input]');
    if (occasionInput) occasionInput.selectedIndex = 0;

    const specialInstructionsInput = document.querySelector('[data-special-instructions-input]');
    if (specialInstructionsInput) specialInstructionsInput.value = '';

    const datePickerInput = document.querySelector('[data-date-picker-input]');
    if (datePickerInput) datePickerInput.value = '';
    
    // Reset custom calendar selection
    selectedCalendarDate = null;
    const today = getNZDate();
    currentCalendarMonth = today.getMonth();
    currentCalendarYear = today.getFullYear();

    const charCount = document.querySelector('[data-char-count]');
    if (charCount) charCount.textContent = '0';

    const quickButtons = document.querySelectorAll('[data-date-quick]');
    quickButtons.forEach(function(btn) {
      btn.classList.remove('delivery-date__quick-btn--active');
    });

    const calendarWrapper = document.querySelector('[data-calendar-wrapper]');
    if (calendarWrapper) calendarWrapper.style.display = 'none';

    currentDeliveryMethod = 'delivery';
    
    updateAddToCartButton(false);
  }

  // ============================================
  // TOGGLE DELIVERY/PICKUP FIELDS
  // ============================================

  function toggleFieldsForMethod(method) {
    const deliveryOnlyFields = document.querySelector('[data-delivery-only-fields]');
    const phoneSection = document.querySelector('[data-phone-section]');
    const pickupSection = document.querySelector('[data-pickup-section]');
    const dateTitle = document.querySelector('[data-date-title]');
    const cardMessageRequired = document.querySelector('[data-card-message-required]');
    const cardMessageLabel = document.querySelector('[data-card-message-label]');

    if (method === 'delivery') {
      // Show delivery-only fields
      if (deliveryOnlyFields) deliveryOnlyFields.style.display = 'block';
      if (phoneSection) phoneSection.style.display = 'block';
      if (pickupSection) pickupSection.style.display = 'none';
      if (dateTitle) dateTitle.textContent = CONFIG.dateTitleDelivery;
      
      // Card message is required for delivery
      if (cardMessageRequired) cardMessageRequired.style.display = 'inline';
      if (cardMessageLabel) cardMessageLabel.textContent = 'Card Message';
      
      // Clear pickup-specific values
      syncToHiddenInput('input-delivery-suburb', '');
      const suburbInput = document.querySelector('[data-suburb-input]');
      if (suburbInput) suburbInput.value = '';
      
    } else {
      // Hide delivery-only fields
      if (deliveryOnlyFields) deliveryOnlyFields.style.display = 'none';
      if (phoneSection) phoneSection.style.display = 'none';
      if (pickupSection) pickupSection.style.display = 'block';
      if (dateTitle) dateTitle.textContent = CONFIG.dateTitlePickup;
      
      // Card message is optional for pickup
      if (cardMessageRequired) cardMessageRequired.style.display = 'none';
      if (cardMessageLabel) cardMessageLabel.textContent = 'Card Message (Optional)';
      
      // Set pickup address
      syncToHiddenInput('input-delivery-suburb', CONFIG.pickupAddress);
      
      // Clear delivery-only values
      syncToHiddenInput('input-location-type', '');
      syncToHiddenInput('input-recipient-phone', '');
    }
  }

  // ============================================
  // INITIALIZE DELIVERY OPTIONS
  // ============================================

  function initDeliveryOptions() {
    console.log('🌸 Initializing delivery options...');

    const deliveryUI = document.querySelector('[data-delivery-options]');
    if (!deliveryUI) {
      console.warn('🌸 Delivery options UI not found');
      return;
    }

    loadSectionSettings();
    clearDeliveryForm();

    // Set default location type
    syncToHiddenInput('input-location-type', 'Residential Home');

    const methodButtons = deliveryUI.querySelectorAll('[data-delivery-method]');
    const quickButtons = deliveryUI.querySelectorAll('[data-date-quick]');
    const calendarWrapper = deliveryUI.querySelector('[data-calendar-wrapper]');
    const datePickerInput = deliveryUI.querySelector('[data-date-picker-input]');
    const suburbInput = deliveryUI.querySelector('[data-suburb-input]');
    const locationTypeInput = deliveryUI.querySelector('[data-location-type-input]');
    const cardMessageInput = deliveryUI.querySelector('[data-card-message-input]');
    const phoneInput = deliveryUI.querySelector('[data-recipient-phone-input]');
    const occasionInput = deliveryUI.querySelector('[data-occasion-input]');
    const specialInstructionsInput = deliveryUI.querySelector('[data-special-instructions-input]');
    const todayDateEl = deliveryUI.querySelector('[data-today-date]');
    const tomorrowDateEl = deliveryUI.querySelector('[data-tomorrow-date]');
    const todayBtn = deliveryUI.querySelector('[data-date-quick="today"]');
    const tomorrowBtn = deliveryUI.querySelector('[data-date-quick="tomorrow"]');
    const cutoffText = deliveryUI.querySelector('[data-cutoff-text]');
    const charCount = deliveryUI.querySelector('[data-char-count]');

    const today = getNZDate();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);

    const todayBlocked = isDateBlocked(today);
    const tomorrowBlocked = isDateBlocked(tomorrow);
    const todayAvailable = !todayBlocked && isBeforeCutoff();

    if (todayDateEl) todayDateEl.textContent = formatDateShort(today);
    if (tomorrowDateEl) tomorrowDateEl.textContent = formatDateShort(tomorrow);

    // Today button availability
    if (todayBtn) {
      if (todayBlocked || !todayAvailable) {
        todayBtn.setAttribute('data-available', 'false');
        todayBtn.style.opacity = '0.4';
        todayBtn.style.cursor = 'not-allowed';
        todayBtn.title = todayBlocked ? 'Not available today' : 'Past cutoff time';
      } else {
        todayBtn.setAttribute('data-available', 'true');
        todayBtn.style.opacity = '1';
        todayBtn.style.cursor = 'pointer';
        todayBtn.title = '';
      }
    }

    // Tomorrow button availability
    if (tomorrowBtn) {
      if (tomorrowBlocked) {
        tomorrowBtn.setAttribute('data-available', 'false');
        tomorrowBtn.style.opacity = '0.4';
        tomorrowBtn.style.cursor = 'not-allowed';
        tomorrowBtn.title = 'Not available tomorrow';
      } else {
        tomorrowBtn.setAttribute('data-available', 'true');
        tomorrowBtn.style.opacity = '1';
        tomorrowBtn.style.cursor = 'pointer';
        tomorrowBtn.title = '';
      }
    }

    // Set min date on calendar
    if (datePickerInput) {
      const nextAvailable = getNextAvailableDate(today);
      datePickerInput.setAttribute('min', formatDateForInput(nextAvailable));
    }

    // Update cutoff text
    if (cutoffText) {
      const dayOfWeek = today.getDay();
      const weekdayCutoff = CONFIG.cutoffTimes.weekday;
      const saturdayCutoff = CONFIG.cutoffTimes.saturday;
      
      const formatTime = (h, m) => {
        const hour12 = h > 12 ? h - 12 : h;
        const ampm = h >= 12 ? 'pm' : 'am';
        return m > 0 ? `${hour12}:${String(m).padStart(2, '0')}${ampm}` : `${hour12}${ampm}`;
      };

      if (todayBlocked) {
        cutoffText.textContent = 'Delivery not available today. Please select another date.';
      } else if (dayOfWeek === 6) {
        cutoffText.textContent = `Order by ${formatTime(saturdayCutoff.hour, saturdayCutoff.minute)} for same-day delivery`;
      } else {
        cutoffText.textContent = `Order by ${formatTime(weekdayCutoff.hour, weekdayCutoff.minute)} for same-day delivery (Mon-Fri)`;
      }
    }

    // ===== EVENT LISTENERS =====

    // Method toggle
    methodButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        const method = this.getAttribute('data-delivery-method');
        currentDeliveryMethod = method;

        methodButtons.forEach(function(b) {
          b.classList.remove('delivery-toggle__btn--active');
          b.setAttribute('aria-pressed', 'false');
        });
        this.classList.add('delivery-toggle__btn--active');
        this.setAttribute('aria-pressed', 'true');

        syncToHiddenInput('input-delivery-method', method === 'delivery' ? 'Delivery' : 'Pickup');
        toggleFieldsForMethod(method);
        markUserInteraction();
        updateAddToCartButton();
      });
    });

    // Date quick buttons
    quickButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        markUserInteraction();
        const dateType = this.getAttribute('data-date-quick');
        const isAvailable = this.getAttribute('data-available') !== 'false';

        if (!isAvailable) return;

        quickButtons.forEach(function(b) { 
          b.classList.remove('delivery-date__quick-btn--active'); 
        });
        this.classList.add('delivery-date__quick-btn--active');

        if (dateType === 'later') {
          if (calendarWrapper) calendarWrapper.style.display = 'block';
          syncToHiddenInput('input-delivery-date', '');
        } else {
          if (calendarWrapper) calendarWrapper.style.display = 'none';
          const selectedDate = dateType === 'today' ? today : tomorrow;
          syncToHiddenInput('input-delivery-date', formatDateShort(selectedDate));
          if (datePickerInput) {
            datePickerInput.value = formatDateForInput(selectedDate);
          }
        }

        updateAddToCartButton();
      });
    });

    // Calendar input - now using custom calendar
    initCustomCalendar();

    // Suburb input (text with datalist)
    if (suburbInput) {
      ['input', 'change', 'blur'].forEach(function(eventType) {
        suburbInput.addEventListener(eventType, function() {
          markUserInteraction();
          syncToHiddenInput('input-delivery-suburb', this.value);
          updateAddToCartButton();
        });
      });
    }

    // Location type input
    if (locationTypeInput) {
      locationTypeInput.addEventListener('change', function() {
        markUserInteraction();
        syncToHiddenInput('input-location-type', this.value);
        updateAddToCartButton();
      });
    }

    // Phone input
    if (phoneInput) {
      ['input', 'change', 'blur'].forEach(function(eventType) {
        phoneInput.addEventListener(eventType, function() {
          markUserInteraction();
          syncToHiddenInput('input-recipient-phone', this.value);
          updateAddToCartButton();
        });
      });
    }

    // Occasion input
    if (occasionInput) {
      occasionInput.addEventListener('change', function() {
        markUserInteraction();
        syncToHiddenInput('input-occasion', this.value);
        updateAddToCartButton();
      });
    }

    // Card message input
    if (cardMessageInput) {
      ['input', 'change', 'blur'].forEach(function(eventType) {
        cardMessageInput.addEventListener(eventType, function() {
          markUserInteraction();
          syncToHiddenInput('input-card-message', this.value);
          if (charCount) {
            charCount.textContent = this.value.length;
          }
          updateAddToCartButton();
        });
      });
    }

    // Special instructions input
    if (specialInstructionsInput) {
      ['input', 'change', 'blur'].forEach(function(eventType) {
        specialInstructionsInput.addEventListener(eventType, function() {
          syncToHiddenInput('input-special-instructions', this.value);
        });
      });
    }

    // Initial button state
    updateAddToCartButton(false);
    
    // Start countdown timer
    startCountdownTimer();
    
    console.log('🌸 Delivery options initialized');
  }

  // ============================================
  // INITIALIZE ADD-ONS
  // ============================================

  function initAddons() {
    console.log('🌸 Initializing add-ons...');

    const addonsContainer = document.querySelector('[data-product-addons]');
    if (!addonsContainer) {
      console.log('🌸 No add-ons container found');
      return;
    }

    const addonItems = addonsContainer.querySelectorAll('[data-addon-item]');
    const summaryEl = addonsContainer.querySelector('[data-addons-summary]');
    const totalEl = addonsContainer.querySelector('[data-addons-total]');

    window.selectedAddons = [];

    addonItems.forEach(function(item) {
      const checkbox = item.querySelector('[data-addon-checkbox]');
      const select = item.querySelector('[data-addon-select]');
      if (checkbox) checkbox.checked = false;
      if (select) select.selectedIndex = 0;
      item.classList.remove('product-addon__item--selected');
    });
    if (summaryEl) summaryEl.style.display = 'none';

    function updateAddonSummary() {
      let total = 0;
      window.selectedAddons = [];

      addonItems.forEach(function(item) {
        const checkbox = item.querySelector('[data-addon-checkbox]');
        const select = item.querySelector('[data-addon-select]');
        const itemPrice = parseInt(item.getAttribute('data-addon-price')) || 0;
        let variantId = item.getAttribute('data-addon-variant-id');
        const title = item.getAttribute('data-addon-title') || '';

        let isSelected = false;
        let selectedVariantId = variantId;
        let price = itemPrice;

        if (checkbox && checkbox.checked) {
          isSelected = true;
        } else if (select && select.value) {
          isSelected = true;
          selectedVariantId = select.value;
          const opt = select.options[select.selectedIndex];
          price = parseInt(opt.getAttribute('data-price')) || itemPrice;
        }

        if (isSelected && selectedVariantId) {
          window.selectedAddons.push({
            variantId: selectedVariantId,
            quantity: 1,
            title: title
          });
          total += price;
          item.classList.add('product-addon__item--selected');
        } else {
          item.classList.remove('product-addon__item--selected');
        }
      });

      if (summaryEl && totalEl) {
        if (total > 0) {
          summaryEl.style.display = 'block';
          totalEl.textContent = '$' + (total / 100).toFixed(2);
        } else {
          summaryEl.style.display = 'none';
        }
      }
    }

    addonItems.forEach(function(item) {
      const checkbox = item.querySelector('[data-addon-checkbox]');
      const select = item.querySelector('[data-addon-select]');
      if (checkbox) checkbox.addEventListener('change', updateAddonSummary);
      if (select) select.addEventListener('change', updateAddonSummary);
    });

    console.log('🌸 Add-ons initialized');
  }

  // ============================================
  // FORM SUBMISSION HANDLER
  // ============================================

  function initFormHandler() {
    console.log('🌸 Initializing form handler...');

    const productForms = document.querySelectorAll('product-form');
    
    productForms.forEach(function(productForm) {
      if (productForm.dataset.flowersHandlerAttached) return;
      productForm.dataset.flowersHandlerAttached = 'true';

      const form = productForm.querySelector('form');
      if (!form) return;

      form.addEventListener('submit', function(e) {
        if (isSubmitting) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        }

        const validation = validateForm();
        if (!validation.isValid) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          userHasInteracted = true;
          updateAddToCartButton(true);
          alert('Please complete the required fields:\n• ' + validation.missingFields.join('\n• '));
          return false;
        }

        if (!window.selectedAddons || window.selectedAddons.length === 0) {
          return true;
        }

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        isSubmitting = true;

        const formData = new FormData(form);
        const mainVariantId = formData.get('id');
        const mainQuantity = parseInt(formData.get('quantity')) || 1;

        const mainItem = {
          id: parseInt(mainVariantId),
          quantity: mainQuantity,
          properties: {}
        };

        for (const pair of formData.entries()) {
          const key = pair[0];
          const value = pair[1];
          if (key.indexOf('properties[') === 0 && value) {
            const propName = key.replace('properties[', '').replace(']', '');
            mainItem.properties[propName] = value;
          }
        }

        const items = [mainItem];

        window.selectedAddons.forEach(function(addon) {
          items.push({
            id: parseInt(addon.variantId),
            quantity: addon.quantity,
            properties: {
              '_Addon': 'Yes'
            }
          });
        });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
        .then(function(response) {
          if (response.ok) {
            window.location.href = '/cart';
          } else {
            return response.json().then(function(error) {
              console.error('🌸 Cart error:', error);
              alert(error.description || 'Error adding to cart');
              isSubmitting = false;
            });
          }
        })
        .catch(function(err) {
          console.error('🌸 Fetch error:', err);
          alert('Error adding to cart. Please try again.');
          isSubmitting = false;
        });

        return false;
      }, true);
    });

    console.log('🌸 Form handlers initialized');
  }

  // ============================================
  // MAIN INIT
  // ============================================

  function init() {
    console.log('🌸 Flowers on Ramarama: Starting initialization...');
    
    isSubmitting = false;
    
    initDeliveryOptions();
    initAddons();
    initFormHandler();
    console.log('🌸 Flowers on Ramarama: Initialization complete!');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('pageshow', function(event) {
    if (event.persisted) {
      init();
    }
  });

  document.addEventListener('shopify:section:load', init);

})();